var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _vm.shouldDisplayResponseCardTitle
        ? _c(
            "div",
            [
              _vm.responseCard.title && _vm.responseCard.title.trim()
                ? _c(
                    "v-card-title",
                    {
                      staticClass: "red lighten-5",
                      attrs: { "primary-title": "" }
                    },
                    [
                      _c("span", { staticClass: "headline" }, [
                        _vm._v(_vm._s(_vm.responseCard.title))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.responseCard.subTitle
        ? _c("v-card-text", [
            _c("span", [_vm._v(_vm._s(_vm.responseCard.subTitle))])
          ])
        : _vm._e(),
      _vm.responseCard.imageUrl
        ? _c("v-card-media", {
            attrs: {
              src: _vm.responseCard.imageUrl,
              contain: "",
              height: "33vh"
            }
          })
        : _vm._e(),
      _vm.responseCard.buttons
        ? _c(
            "v-card-actions",
            { staticClass: "button-row" },
            _vm._l(_vm.responseCard.buttons, function(button, id) {
              return _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: button.text && button.value,
                      expression: "button.text && button.value"
                    }
                  ],
                  key: id,
                  staticClass: "secondarybtn",
                  on: {
                    click: function($event) {
                      return _vm.onButtonClick(button.value)
                    }
                  }
                },
                [
                  _c(
                    "li",
                    {
                      style: {
                        "font-size": "4vw",
                        marginLeft: "6vw",
                        color: "#C1C1C1"
                      }
                    },
                    [
                      _c("div", { staticClass: "buttonContainer" }, [
                        _c("div", [_vm._v(" " + _vm._s(button.text) + " ")])
                      ])
                    ]
                  )
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm.responseCard.attachmentLinkUrl
        ? _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  staticClass: "red lighten-5",
                  attrs: {
                    flat: "",
                    tag: "a",
                    href: _vm.responseCard.attachmentLinkUrl,
                    target: "_blank"
                  }
                },
                [_vm._v(" Open Link ")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }